import type { VideoBroadcastStateParams } from '@repo/go-widgets';

import type { TVideobroadcastSerializedInternalState } from './VideobroadcastWidget.entity';

type LegacyVideobroadcastStateParams = Partial<VideoBroadcastStateParams> & {
  dvrOn?: unknown;
  playbackMode?: unknown;
  playbackTimeMs?: unknown;
};

function isVideoBroadcastPlaybackMode(value: unknown): value is VideoBroadcastStateParams['playbackMode'] {
  return value === 'live' || value === 'archive';
}

function normalizeVideobroadcastStateParams(stateParams: object): Partial<VideoBroadcastStateParams> {
  const { dvrOn, playbackMode, playbackTimeMs, ...rest } = stateParams as LegacyVideobroadcastStateParams;
  const normalizedStateParams = rest as Partial<VideoBroadcastStateParams>;

  if (isVideoBroadcastPlaybackMode(playbackMode)) {
    normalizedStateParams.playbackMode = playbackMode;
  } else if (typeof dvrOn === 'boolean') {
    normalizedStateParams.playbackMode = dvrOn ? 'archive' : 'live';
  }

  if (typeof playbackTimeMs === 'number' || playbackTimeMs === null) {
    normalizedStateParams.playbackTimeMs = playbackTimeMs;
  }

  return normalizedStateParams;
}

export function parseVideobroadcastInternalState(state: object): TVideobroadcastSerializedInternalState {
  let wellId: number | null = null;
  let stateParams: Partial<VideoBroadcastStateParams> = {};

  if ('wellId' in state && typeof state.wellId === 'number') {
    wellId = state.wellId;
  }

  if ('stateParams' in state && typeof state.stateParams === 'object' && !!state.stateParams) {
    stateParams = normalizeVideobroadcastStateParams(state.stateParams);
  }

  return {
    wellId,
    stateParams,
  };
}
